import gql from 'graphql-tag';

const MOBILE_TRAINING_ASSIGNMENT_FRAGMENT = gql`
	fragment mobileTrainingAssignment on TrainingAssignment {
		id
		assignmentStatus
		dueAt
		startedAt
		submittedAt
		resolvedAt
		canCompletePracticalTraining
		trainingModuleSnapshot
		employee {
			id
			firstName
			lastName
			preferredName
		}
		trainingModule {
			id
			title
			description
			trainingType
			practicalChecklistItems
		}
		latestResult {
			id
			practicalChecklistCompletions
			practicalOutcome
			reviewNotes
			submittedAt
			trainer {
				id
				fullName
			}
		}
	}
`;

export const GET_MOBILE_TRAINING_ASSIGNMENTS = gql`
	query getTrainingAssignments(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: TrainingAssignmentFilter
	) {
		getTrainingAssignments(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...mobileTrainingAssignment
			}
			count
			mobileOnlineCount
		}
	}
	${MOBILE_TRAINING_ASSIGNMENT_FRAGMENT}
`;

export const COMPLETE_PRACTICAL_TRAINING_ASSIGNMENT = gql`
	mutation completePracticalTrainingAssignment($input: CompletePracticalTrainingAssignmentInput!) {
		completePracticalTrainingAssignment(input: $input) {
			...mobileTrainingAssignment
		}
	}
	${MOBILE_TRAINING_ASSIGNMENT_FRAGMENT}
`;
